"use strict";

exports.__esModule = true;
var _PluginButton = require("./PluginButton");
Object.keys(_PluginButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PluginButton[key]) return;
  exports[key] = _PluginButton[key];
});